<nz-rate [(ngModel)]="score" [nzDisabled]="readonly"></nz-rate>
